<template>
  <div v-if="show" class="submission-overlay">
    <div class="submission-overlay-content">
      <div class="spinner-container">
        <div class="spinner"></div>
      </div>
      <h3 class="submission-title">{{ title }}</h3>
      <p class="submission-message">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormSubmissionOverlay',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Submitting Form'
    },
    message: {
      type: String,
      default: 'Please wait while we process your submission...'
    }
  }
}
</script>

<style scoped>
.submission-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.submission-overlay-content {
  background-color: white;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  max-width: 90%;
  width: 400px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.spinner-container {
  margin-bottom: 20px;
}

.spinner {
  display: inline-block;
  width: 60px;
  height: 60px;
  border: 5px solid rgba(0, 123, 255, 0.2);
  border-radius: 50%;
  border-top-color: #007bff;
  animation: spin 1s ease-in-out infinite;
}

.submission-title {
  font-size: 24px;
  margin-bottom: 15px;
  color: #333;
}

.submission-message {
  font-size: 16px;
  color: #666;
  margin-bottom: 0;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Mobile responsive styles */
@media (max-width: 576px) {
  .submission-overlay-content {
    width: 85%;
    padding: 20px;
  }
  
  .spinner {
    width: 50px;
    height: 50px;
  }
  
  .submission-title {
    font-size: 20px;
  }
  
  .submission-message {
    font-size: 14px;
  }
}
</style>
